/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ConferenceAnnouncementNotice_viewer$ref: FragmentReference;
declare export opaque type ConferenceAnnouncementNotice_viewer$fragmentType: ConferenceAnnouncementNotice_viewer$ref;
export type ConferenceAnnouncementNotice_viewer = {|
  +notice: ?{|
    +id: string,
    +dismissedAt: ?any,
  |},
  +$refType: ConferenceAnnouncementNotice_viewer$ref,
|};
export type ConferenceAnnouncementNotice_viewer$data = ConferenceAnnouncementNotice_viewer;
export type ConferenceAnnouncementNotice_viewer$key = {
  +$data?: ConferenceAnnouncementNotice_viewer$data,
  +$fragmentRefs: ConferenceAnnouncementNotice_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConferenceAnnouncementNotice_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "namespace",
          "value": "EVENT"
        },
        {
          "kind": "Literal",
          "name": "scope",
          "value": "unblockconf-2022-schedule"
        }
      ],
      "concreteType": "Notice",
      "kind": "LinkedField",
      "name": "notice",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dismissedAt",
          "storageKey": null
        }
      ],
      "storageKey": "notice(namespace:\"EVENT\",scope:\"unblockconf-2022-schedule\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '290c753ceb60b94d75a9f6f84d7f74e5';

module.exports = node;
